import { useState,useEffect } from "react";
import { CurtainReveal } from "./ui/curtainReveal";

const IntroScreen = ({ onComplete }) => {
  useEffect(() => {
    const t = setTimeout(() => onComplete(), 2200);
    return () => clearTimeout(t);
  }, [onComplete]);
  return <CurtainReveal />;
};

export default IntroScreen;